<div class="footer-main">
  <div class="footer-item">&copy; {{copyright}}</div>
  <app-separator></app-separator>
  <div class="footer-item">Company Confidential</div>
  <app-separator></app-separator>
  <div class="footer-item">Technical contact: <a href="https://chevron.service-now.com/mychevron?id=sc_cat_item_guide&sys_id=9c08a21edb126450182e1dca48961981">Contact Us</a></div>
  <app-separator></app-separator>
  <div class="footer-item">OpCo: <a href="https://intranet.chevron.com/content/menu/67a680ec91622c162a97dd65">Technical Center</a></div>
  
</div>
